<template lang="html">
<section class="material-list-model" :style="boxStyle">
  <div class="check-all" v-if="isMultiple">
    <input id="check-all" type="checkbox" name="checkAll" v-model="isCheckAll">
    <label for="check-all" class="check-item">
      <i class="ti-check"></i>
    </label>
    <label for="check-all" class="info">全选</label>
  </div>
  <ul class="material-list" ref="materialList">
    <li
      class="material-item"
      :key="material.id + '' + index"
      :data-id="material.id"
      :draggable="isItemDrag && !isBlack(material.id)"
      :class="{'martial-info-height': !material.isOpen,
                'black': isBlack(material.id),
                'checked': material.isCheck || deleteIds.indexOf(material.id) !== -1}"
      v-for="(material, index) in materialList"
      @dragstart="dragStart($event, material)"
      @dragend="dragEnd($event, material)">
      <div class="header">
        <ul class="material-info-list">
          <li class="id-info">
            ID {{material.id}}
          </li>
          <li class="name-info" v-if="material.name">
            {{material.name}}
          </li>
          <slot name="materialInfo" :data="material" :index="index"></slot>
        </ul>
        <!-- <em class="id-info">ID {{material.id}}</em> -->
        <!-- <strong class="name-info" v-if="material.name">{{material.name}}</strong> -->
      </div>
      <div class="content">
        <xes-material-content
          :content="material.content"
          :resource="material.resource"
          :parse-type="material.parse_type + ''"
        ></xes-material-content>
      </div>
      <div class="other-content" v-if="material.parse_type !== '5' && (material.content_teacher || material.material_content || material.analytic)">
        <div class="teacher-content" v-if="material.content_teacher">
          <strong class="content-title">教师版素材</strong>
          <div class="inner-box">
            <xes-material-content
              :content="material.content_teacher"
              :resource="material.resource"
              :parse-type="1"
            ></xes-material-content>
          </div>
        </div>
        <div class="teacher-content" v-if="material.material_content">
          <strong class="content-title">材料</strong>
          <p class="content-info">{{material.material_content}}</p>
        </div>
        <div class="teacher-content" v-if="material.analytic">
          <strong class="content-title">解析</strong>
          <p class="content-info">{{material.analytic}}</p>
        </div>
      </div>
      <p class="more">
        <span class="add-material" v-if="!isBlack(material.id) && isSingle && deleteIds.indexOf(material.id) === -1" @click="selectOneMaterial(material)">
          <i class="item-icon ti-plus" :class="{'is-reverse': material.isOpen}"></i>
          选素材
        </span>
        <span class="add-material" v-if="!isBlack(material.id) && isSingle && deleteIds.indexOf(material.id) !== -1" @click="deleteOneMaterial(material)">
          <i class="item-icon ti-minus" :class="{'is-reverse': material.isOpen}"></i>
          移除
        </span>
        <span class="checkbox" v-if="isMultiple && !isBlack(material.id)">
          <input :id="'check' + material.id" type="checkbox" name="material-check" v-model="material.isCheck" @change="checkOneMaterial(material)">
          <label class="check" :for="'check' + material.id">
            <i class="ti-check"></i>
          </label>
          <label :for="'check' + material.id">
            选择
          </label>
        </span>
        <span class="open-more" v-if="material.isShowMore">
          <i class="item-icon el-input__icon el-icon-caret-top" :class="{'is-reverse': material.isOpen}"></i>
          <span @click="material.isOpen = !material.isOpen">素材详情</span>
        </span>
      </p>
      <div class="list-line">
      </div>
    </li>
  </ul>
</section>
</template>

<script>
import styleMixin from 'xes-frontend-ui/src/mixins/styleMixin'
import XesMaterialContent from 'xes-frontend-ui/packages/material-content'
import { httpRequest, uploadXHR } from 'xes-frontend-ui/src/utils/ajax'
export default {
  name: 'xes-material-list',
  mixins: [styleMixin],
  props: {
    height: [String, Number],
    width: [String, Number],
    isItemDrag: { // 是否支持拖拽
      type: Boolean,
      default: false
    },
    action: { // 请求接口url
      type: String,
      required: true
    },
    params: { // 自定义请求参数
      type: Object,
      default () {
        return {
          perpage: 10,
          curpage: 1,
          divisionId: '',
          subjectId: '',
          gradeId: '',
          versionId: '',
          status: '',
          searchType: '',
          searchValue: '',
          sign: ''
        }
      }
    },
    headers: { // 自定义请求头
      type: Object,
      default () {
        return {}
      }
    },
    token: {
      type: String,
      required: true
    },
    withCredentials: { // 跨域时是否支持发送cookie
      type: Boolean,
      default: false
    },
    keyMap: { // 列表展示项对应key
      type: Object,
      default () {
        return {}
      }
    },
    blackIds: { // 黑名单ID列表，列表中的项置灰、不允许选择、拖拽
      type: Array,
      default () {
        return []
      }
    },
    deleteIds: { // 移除名单ID列表，名单中的项显示移除按钮，不显示选择按钮
      type: Array,
      default () {
        return []
      }
    },
    isSingle: { // 是否支持单选
      type: Boolean,
      default: false
    },
    isMultiple: { // 是否支持多选
      type: Boolean,
      default: false
    }
  },
  components: {
    XesMaterialContent
  },
  created () {
    this.keysMap = Object.assign({}, this.originalKeyMap, this.keyMap)
  },
  computed: {
    isCheckAll: {
      get () {
        if (!this.materialList.length) return false
        return this.materialChecks.length + this.blackIds.length == this.materialList.length
      },
      set (val) {
        this.materialList = this.materialList.map(item => {
          item.isCheck = val
          return item
        })
        if (val) {
          this.materialChecks = this.materialList.filter(item => {
            return this.blackIds.indexOf(item.id) == -1
          })
          this.$emit('material-add-checks', this.materialChecks)
        } else {
          this.$emit('material-delete-checks', this.materialChecks)
          this.materialChecks = []
        }
      }
    },
    resultParams () {
      let params = JSON.parse(JSON.stringify(this.params))
      params = Object.assign({}, params)
      return params
    }
  },
  data () {
    return {
      originalKeyMap: {
        id: 'id',
        name: 'name',
        content: 'content',
        resource: 'resource',
        parse_type: 'parse_type',
        parse_type_name: 'parse_type_name'
      },
      keysMap: {},
      materialList: [],
      materialChecks: []
    }
  },
  watch: {
    blackIds (ids) {
      ids.forEach(item => {
        let index
        const target = this.materialChecks.find((material, i) => {
          index = i
          return material.id == item
        })
        if (target) {
          this.materialChecks.splice(index, 1)
        }
      })
      this.materialList = JSON.parse(JSON.stringify(this.materialList))
    }
  },
  methods: {
    parseHtml (html) {
      html = html.replace(/<\/p>(\n)+/gi, '</p>')
      html = html.replace(/<br>(\n)+/gi, '<br>')
      html = html.replace(/<br \/>(\n)+/gi, '<br />')
      html = html.replace(/\n/gi, function (match) {
        return '<br>'
      })
      let strData = html.replace(/<p>(\s)?<\/p>/g, '<br/>')
      return strData
    },
    getChecksMaterial () {
      return this.materialChecks
    },
    // 设置是否显示black样式
    isBlack (id) {
      return this.blackIds.indexOf(id) !== -1
    },
    // 判断是否显示展开详情按钮
    isShowMore (id, target) {
      if (target) {
        // 获取所有图片，等图片加载完毕，再获取高度计算
        const scrollHeight = target.scrollHeight
        const clientHeight = target.clientHeight
        if (scrollHeight > clientHeight) {
          // 找到列表数据中的目标数据
          let index
          const targetMaterial = this.materialList.find((item, i) => {
            index = i
            return item.id == id
          })
          if (targetMaterial) {
            targetMaterial.isShowMore = true
            this.materialList.splice(index, 1, targetMaterial)
          }
        }
      }
    },
    handleShowMore () {
      this.$nextTick(() => {
        // 获取materialList下的所有图片，
        // 设置等待一秒后再计算是否显示展开详情，因为图片等的资源加载需要时间，
        this.materialList.forEach(item => {
          // 获取对应li下的图片，若图片有未加载完，等待图片加载完再计算高度
          const listEle = this.$refs.materialList
          const lis = listEle.getElementsByClassName('material-item')
          const target = Array.prototype.slice.call(lis).find(li => {
            const itemId = li.dataset.id
            return itemId == item.id
          })
          let imgs = target.getElementsByTagName('img')
          let timer = null
          const _this = this
          function shutoff () {
            _this.isShowMore(item.id, target)
          }
          if (imgs && imgs.length) {
            shutoff()
            // 若已经是展开的，则不处理
            if (item.isShowMore) return
            imgs = Array.prototype.slice.call(imgs)
            imgs.forEach((img) => {
              img.onload = () => {
                clearTimeout(timer)
                timer = setTimeout(shutoff, 200)
              }
            })
          } else {
            shutoff()
          }
        })
      })
    },
    getList () {
      if (!this.action) {
        throw new Error('getMaterialList地址为空！')
      }
      const option = {
        params: this.resultParams,
        headers: Object.assign({}, this.headers, { jytoken: this.token || '' }),
        withCredentials: this.withCredentials,
        action: this.action
      }
      return httpRequest(option).then(res => {
        if (res.status == 100) {
          // 请求成功,组织列表数据
          this.materialList = res.data.lists.map(item => {
            const keys = Object.keys(this.keysMap)
            if (item.parse_type == 5) {
              const result = {
                content: this.parseHtml(item.content),
                keywords: item.keywords,
                analytic: this.parseHtml(item.analytic)
              }
              item.content = JSON.stringify([result])
            }
            const material = Object.assign({}, item, {
              isOpen: false,
              isShowMore: false,
              isCheck: false
            })
            keys.forEach(key => {
              material[key] = item[this.keysMap[key]]
            })
            return material
          })
          // 控制计算展开详情。
          // 涉及到一些异步处理，未想到好的解决方案，暂不处理
          this.handleShowMore()
          this.$emit('ajax-success', res.data)
        } else {
          this.$emit('status-error', res)
        }
      }).catch((err) => {
        this.$emit('catch-ajax-error', err)
      })
    },
    dragStart (ev, item) {
      // 处理火狐新开页
      ev.dataTransfer.setData('aaa', '')
      this.$emit('material-drag-start', ev, item)
    },
    dragEnd (ev, item) {
      // 处理火狐新开页
      ev.dataTransfer.setData('aaa', '')
      this.$emit('material-drag-end', ev, item)
    },
    // 点击添加一个素材
    selectOneMaterial (material) {
      this.$emit('add-one-material', material)
    },
    // 点击移除一个素材
    deleteOneMaterial (material) {
      this.$emit('delete-one-material', material)
    },
    // 点击选择一个素材
    checkOneMaterial (material) {
      if (material.isCheck) {
        this.materialChecks.push(material)
        this.$emit('material-add-checks', [material])
      } else {
        let index
        const target = this.materialChecks.find((item, i) => {
          index = i
          return item.id == material.id
        })
        if (target) {
          this.materialChecks.splice(index, 1)
        }
        this.$emit('material-delete-checks', [material])
      }
    },
    // 清空选择项
    clearChecks () {
      this.materialChecks.splice(0, this.materialChecks.length)
      this.materialList = this.materialList.map(item => {
        item.isCheck = false
        return item
      })
    },
    // 设置选中列表
    setChecks (ids) {
      if (!Array.isArray(ids)) {
        throw new Error('传入的参数不是数组')
      }
      const list = this.materialList.map(item => {
        item.isCheck = false
        return item
      })
      const result = []
      list.forEach(item => {
        if (ids.indexOf(item.id) != -1) {
          item.isCheck = true
          result.push(item)
        }
      })
      this.materialChecks = result
      this.materialList = JSON.parse(JSON.stringify(list))
    }
  }
}
</script>



// WEBPACK FOOTER //
// packages/material-list/src/List.vue